export const tabNames = ['GENERAL_INQUIRY', 'FRANCHISE_OPPORTUNITY']